import { computed, type ComputedRef } from "vue";
import { useI18n } from "vue-i18n";
import { getPublicSiteUrl } from "../utils/public-site-url";

export function getPublicAgentDownloadUrl(
  locale: string,
  publicSiteUrl?: string,
): string {
  return getPublicSiteUrl(locale, "download-app", publicSiteUrl);
}

export function usePublicAgentDownloadUrl(): ComputedRef<string> {
  const { locale } = useI18n();
  return computed(() => getPublicAgentDownloadUrl(locale.value));
}
